import React from 'react';
import { Table, Text } from '../../../app-components';
import { ROUTES } from '../../../Lib/constants';
import vars from '../../../theme/vars';
import { listAllUri } from '../../../Queries/subscriptionHistory';
import { shorten } from '../../../Lib/helpers';

const tableItems = {
  lg: {
    columns: [
      {
        header: 'Purchased By',
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>
            {shorten(item?.purchasedByName, 20)}
          </Text>
        ),
        width: 250,
      },
      {
        header: 'Purchased For',
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>
            {shorten(item?.dealerId?.username, 20)}
          </Text>
        ),
        width: 250,
      },
      {
        header: 'Transaction Id',
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>
            {item.transactionMode !== 'CASH' ? item._id : 'N.A'}
          </Text>
        ),
        width: 250,
      },
      {
        header: 'Date Generated',
        type: 'date',
        field: 'transactionDateTime',
        width: 250,
      },
      {
        header: 'Payment Mode',
        type: 'text',
        field: 'transactionMode',
        width: 250,
      },
      {
        header: 'Price',
        render: ({ item }) => {
          return <Text style={{ fontSize: 17 }}>$ {item.price}</Text>;
        },
        width: 250,
      },
    ],
  },
};

export default Table({
  uri: listAllUri,
  ...tableItems,
  action: ({ item }) => ({
    type: 'link',
    link: {
      view: ROUTES.viewSubscriptionHistory.name,
      params: { item: { ...item }, editable: false },
    },
  }),
});
